/*
import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

*/

import React, {Component, hashHistory, DefaultRoute} from  "react";
import { render, IndexRoute } from "react-dom";
import { browserHistory} from "react-router";
import { BrowserRouter as Router, Route} from "react-router-dom";
import { } from "react-router";

import NaviBar from './NaviBar';
import iOSApp from './iOSApp'
import Privacy from './Privacy';
import iOSAppNavi from './iOSAppNavi'
import Ruchen from './Ruchen'
import LAZY from './LAZY'
import EveAlarm from './EveAlarm'
import Home from './Home';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App"><hr/>
      
      < Router>
          <div>
            <NaviBar />
            <Route exact path='/' component={Home}/>
            <Route path="/Ruchen" component={Ruchen} />
            <Route path="/LAZY" component={LAZY} />
            <Route path="/EveAlarm" component={EveAlarm} />
          </div>
        </Router>
        <p>更新日：2020/08/17</p>
      </div>
    );
  }
}

/*
            <Route path='/Privacy' component={Privacy}/>
*/

export default App;